<form [formGroup]="formBuilder">
    <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">

            <!-- Scelta template -->
            <div class="blocks m-3 pt-0 px-0">
                <div class="row px-3">
                    <div class="col-12">
                        <div class="m-3">
                            <i class="far fa-file-alt fa-lg mr-5"></i>
                            <label class="form-label label-fw"> Scegli Template</label>
                        </div>
                    </div>
                </div>
                <div class="row px-3">
                    <div class="row m-3 mb-30">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 t-center">
                            <div>
                                <label>
                                    <input class="checkboxes" type="radio" name="target" [(ngModel)]="template"
                                        (ngModelChange)="onTemplateChange()" [ngModelOptions]="{standalone: true}"
                                        [value]="'MAP'">
                                    <img alt="" class="img" src="/assets/images/custompage_template/template3.jpg">
                                </label>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 t-center">
                            <div>
                                <label>
                                    <input class="checkboxes" type="radio" name="target" [(ngModel)]="template"
                                        (ngModelChange)="onTemplateChange()" [ngModelOptions]="{standalone: true}"
                                        [value]="'CLEAN'">
                                    <img alt="" class="img" src="/assets/images/custompage_template/template4.jpg">
                                </label>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Link alla pagina -->
            <div class="blocks m-3 pt-0 px-0">
                <div class="row px-3">
                    <div class="col-12">
                        <div class="m-3">
                            <i class="fas fa-external-link-alt fa-lg mr-5"></i>
                            <label class="form-label label-fw">Link pagina</label>
                        </div>
                    </div>
                </div>
                <div class="row px-3">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="label-fw d-flex">
                            <div class="d-flex">
                                <a rel="noopener" title="Visualizza pagina" class="btn btn-lg pr-0 blu" href="{{pageUrl}}" target="_blank"
                                    [hidden]="!isVisibleLinkPageUrl">
                                    <i class="fas fa-external-link-alt"></i>
                                    Apri link in un'altro tab.
                                </a>
                                <a title="Visualizza pagina" class="btn btn-lg pr-0 disabled" href="javascript:void(0);"
                                    [hidden]="isVisibleLinkPageUrl">
                                    <i class="fas fa-external-link-alt"></i>
                                    Apri link in un'altro tab.
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <!-- Visibilità -->
            <div class="blocks m-3 pt-0 px-0">
                <div class="row px-3">
                    <div class="col-12">
                        <div class="m-3">
                            <i class="far fa-eye fa-lg mr-5"></i>
                            <label class="form-label label-fw">Visibilità</label>
                        </div>
                    </div>
                </div>
                <div class="row px-3">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="label-fw mx-3 d-flex">
                            <div class="d-flex">
                                Stato di pubblicazione
                            </div>
                            <div class="form-check form-switch d-flex">
                                <div class="justify-content-end">
                                    <label class="switch">
                                        <input formControlName="published" name="published" id="field_published"
                                            type="checkbox">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            

            <!-- Informazioni generali-->

            <div class="blocks m-3 pt-0 px-0">
                <div class="row pt-4 px-4">
                    <div class="d-inline">
                        <i class="far fa-cog block-icons mx-2"></i>
                        <span class="card-title">System</span>
                    </div>
                </div>

                <div class="row pt-4 px-4">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <label for="field_createdAt" class="form-label label-fw">Data creazione</label>
                            <input value="{{systemView.createdAt}}" type="text" class="form-control form-fw "
                                id="field_createdAt" placeholder="gg/mm/aaaa" disabled>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <label for="field_createdBy" class="form-label label-fw">Creato da</label>
                            <input value="{{systemView.createdBy}}" type="email" class="form-control form-fw "
                                id="field_createdBy" placeholder="Creato da" disabled>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <label for="field_modifiedAt" class="form-label label-fw">
                                Data ultima modifica
                            </label>
                            <input value="{{systemView.modifiedAt}}" type="text" class="form-control form-fw "
                                id="field_modifiedAt" placeholder="gg/mm/aaaa" disabled>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <label for="field_modifiedBy" class="form-label label-fw">Modificato da</label>
                            <input value="{{systemView.modifiedBy}}" type="email" class="form-control form-fw "
                                id="field_modifiedBy" placeholder="Modificato da" disabled>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="blocks m-3 pt-0 px-0">
                <div class="row px-3">
                    <div class="col-12">
                        <div class="m-3">
                            <i class="far fa-edit fa-lg mr-5"></i>
                            <label class="form-label label-fw"> Contenuto Principale</label>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Titolo*</label>
                            <input formControlName="title" name="title" type="text"
                                [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true}"
                                class="form-control form-fw " id="field_title" placeholder="Titolo pagina custom">
                            <div class="invalid-feedback" *ngIf="formControls.title.touched">
                                <span *ngIf="formControls.title.errors && formControls.title.errors?.required">
                                    Title is required
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Etichetta Menu</label>
                            <input formControlName="menuLabel" name="menuLabel" type="text"
                                [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true}"
                                class="form-control form-fw " id="field_menuLabel" placeholder="Etichetta Menu">
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Breadcrumb</label>
                            <ckeditor #breadcrumb="ngModel" [(ngModel)]="breadcrumbValue"
                                [ngModelOptions]="{standalone: true}" name="breadcrumb" [config]="ckeConfig"
                                (ngModelChange)="change()" debounce="500">
                            </ckeditor>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="m-3">
                            <label class="form-label label-fw">SEO ID</label>
                            <input formControlName="seoId" name="seoId" type="text"
                                [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true}"
                                class="form-control form-fw " id="field_title" placeholder="SEO ID">
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="m-3">
                            <label class="form-label label-fw">Title SEO</label>
                            <input formControlName="seoTitle" name="seoTitle" type="text"
                                [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true}"
                                class="form-control form-fw " id="field_seoTitle" placeholder="Title SEO">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Descrizione SEO </label>
                            <textarea formControlName="seoDescription" name="seoDescription"
                                class="form-control area area-m" id="exampleFormControlTextarea1" rows="2"></textarea>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-30">
                        <div class="my-4 d-flex">
                            <div class="mx-3">
                                <label class="form-label label-fw form-check-label toggle-text">SEO noindex</label>
                            </div>
                            <div class="switch-p">
                                <label class="switch">
                                    <input formControlName="seoNoindex" name="seoNoindex" id="field_seoNoindex"
                                        type="checkbox">
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Scegli tipologia per l'immagine di testa</label>
                            <div class="col-6">
                                <div class="flex space">
                                    <div>
                                        <label>
                                            <input type="radio" formControlName="imageType" name="imageType"
                                                [value]="'SINGLE_IMAGE'">
                                            Immagine singola
                                        </label>
                                    </div>
                                    <div>
                                        <label>
                                            <input type="radio" formControlName="imageType" name="imageType"
                                                [value]="'GALLERY'">
                                            Galleria
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-12 mb-30" *ngIf="(formControls.imageType.value === 'GALLERY')">
                        <div class="m-3">
                            <label class="form-label label-fw">Galleria immagini</label>
                            <ng-autocomplete #galleryIds placeholder="Cerca galleria" [data]="galleryIdsSuggestion"
                                [searchKeyword]="galleryIdsKeyword" (selected)='selectGalleryIdsEvent($event)'
                                (inputChanged)='getGalleryIdsList($event)' (inputFocused)='onGalleryIdsFocused($event)'
                                [itemTemplate]="itemGalleryIdsTemplate" [formControl]="initialGalleryValue"
                                (inputCleared)="searchGalleryIdsCleared()"
                                [notFoundTemplate]="notFoundGalleryIdsTemplate" [debounceTime]="600"
                                [isLoading]="isGalleryIdsKeywordLoadingResult" [minQueryLength]="2">
                            </ng-autocomplete>
                            <ng-template #itemGalleryIdsTemplate let-item>
                                <div class="col-12">
                                    <div class="mx-3">
                                        <span [innerHTML]="item.name"></span>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template #notFoundGalleryIdsTemplate let-notFound>
                                {{errorMsg}}
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 mb-30" *ngIf="(formControls.imageType.value === 'SINGLE_IMAGE')">
                        <div class="m-3">
                            <label class="form-label label-fw">Immagine Principale</label><br>
                            <button type="button" class="btn btn-outline-warning btn-outline-fw text my-3"
                                (click)="openLoadImageFromPC()">
                                Carica da PC
                            </button>
                            <button type="button" class="btn btn-outline-warning btn-outline-fw text my-3"
                                (click)="openLoadImageFromDAM()">
                                Carica da D.A.M.
                            </button>
                            <button type="button" class="btn btn-outline-warning btn-outline-fw text my-3"
                                (click)="deleteImage()">
                                Elimina
                            </button>

                            <div class="thumb-area d-flex justify-content-center my-3">
                                <div class="icona justify-content-center" [hidden]="visibleImageChoice">
                                    <i class="fas fa-camera"></i>
                                </div>
                                <img [src]="imageChoice.url" alt="Anteprima" class="img-thumbnail img-thumbnail-dim"
                                    [hidden]="!visibleImageChoice">
                            </div>

                            <input type="text" formControlName="previewImage" name="previewImage" hidden>
                        </div>
                    </div>

                    <div class="col-12 mb-30">
                        <div class="m-3">
                            <label class="form-label label-fw">Contenuto Principale</label>
                            <ckeditor #mainContent="ngModel" [(ngModel)]="mainContentValue"
                                [ngModelOptions]="{standalone: true}" name="mainContent" [config]="ckeConfig"
                                (ngModelChange)="change()" debounce="500">
                            </ckeditor>

                        </div>
                    </div>
                    <div class="col-12 mb-30">
                        <div class="d-flex">
                            <div class="mx-3">
                                <label class="form-label label-fw form-check-label toggle-text">Rimuovi footer</label>
                            </div>
                            <div class="switch-p">
                                <label class="switch">
                                    <input formControlName="removeFooter" name="removeFooter" id="field_removeFooter"
                                        type="checkbox">
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="blocks m-3 pt-0 px-0">
                <div class="row px-3">
                    <div class="col-6">
                        <div class="m-3">
                            <i class="far fa-newspaper fa-lg mr-5"></i>
                            <label class="form-label label-fw">News e Approfondimenti</label>
                        </div>
                    </div>
                </div>
                <div class="row px-3">
                    <div class="col-12">
                        <div class="my-3">
                            <div class="d-flex">
                                <div class="mx-3">
                                    <label class="form-label label-fw form-check-label toggle-text">Abilita per
                                        categoria News e Approfondimenti</label>
                                </div>
                                <div class="switch-p">
                                    <label class="switch">
                                        <input formControlName="enableByCategoryNewsAndInsights"
                                            name="enableByCategoryNewsAndInsights"
                                            id="field_enableByCategoryNewsAndInsights" type="checkbox">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Titolo News e Approfondimenti</label>
                            <input formControlName="newsInsightsTitle" name="newsInsightsTitle" type="text"
                                [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true}"
                                class="form-control form-fw " id="field_newsInsightsTitle"
                                placeholder="Titolo News e Approfondimenti">
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Abstract News e Approfondimenti</label>
                            <ckeditor #newsInsightsAbstract="ngModel" [(ngModel)]="newsInsightsAbstractValue"
                                [ngModelOptions]="{standalone: true}" name="newsInsightsAbstract" [config]="ckeConfig"
                                (ngModelChange)="change()" debounce="500">
                            </ckeditor>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Filtri News e Approfondimenti</label>
                            <ng-autocomplete #newsIds placeholder="Cerca Filtri News e Approfondimenti"
                                [data]="newsIdsSuggestion" [searchKeyword]="newsIdsKeyword"
                                (selected)='selectNewsIdsEvent($event)' (inputChanged)='getNewsIdsList($event)'
                                (inputFocused)='onNewsIdsFocused($event)' [itemTemplate]="itemNewsIdsTemplate"
                                (inputCleared)="searchNewsIdsCleared()" [notFoundTemplate]="notFoundNewsIdsTemplate"
                                [debounceTime]="600" [isLoading]="isNewsIdsKeywordLoadingResult" [minQueryLength]="2">
                            </ng-autocomplete>
                            <ng-template #itemNewsIdsTemplate let-item>
                                <div class="col-12">
                                    <div class="mx-3">
                                        <span [innerHTML]="item.name"></span>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template #notFoundNewsIdsTemplate let-notFound>
                                {{errorMsg}}
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 mb-30">
                        <div class="m-3">
                            <fieldset class="fieldset-fw" [hidden]="newsSelected.length === 0">
                                <legend hidden></legend>
                                <app-draggable-list-chip [itemList]="newsSelected" [labelKeys]="labelKeysNewsIds"
                                    (changeItemList)="onChangeItemListNewsIdsSelected($event)">
                                </app-draggable-list-chip>
                            </fieldset>
                        </div>
                    </div>
                </div>
                <!--Buttons-->
                <div *ngIf="template === 'CLEAN'" class="row">
                    <div class="col-12">
                        <div class="my-4 text-center"><button
                                [disabled]="(form.status === 'INVALID' && form.touched === true) || form.touched === false "
                                (click)="clickButtonSave()" type="button" class="btn btn-fw text me-3">Salva modifiche</button>
                            <button type="button" (click)="clickButtonCancel()" class="btn btn-outline-fw text">Annulla</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="template === 'MAP'" class="row">
        <div class="col">
            <div class="blocks m-3 pt-0 px-0">
                <div class="row px-3">
                    <div class="col-6">
                        <div class="m-3">
                            <i class="far fa-map fa-lg mr-5"></i>
                            <label class="form-label label-fw">
                                Contenuto con Mappa
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row px-3">
                    <div class="col-12">
                        <div class="my-3">
                            <div class="d-flex">
                                <div class="mx-3">
                                    <label class="form-label label-fw form-check-label toggle-text">Lista store su
                                        mappa</label>
                                </div>
                                <div class="switch-p">
                                    <label class="switch">
                                        <input formControlName="enableListStoreOnMap" name="enableListStoreOnMap"
                                            id="field_enableListStoreOnMap" type="checkbox" (change)="change()">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Prodotti e Servizi</label>
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12" *ngFor="let product of productsList">
                                    <input value="{{product.id}}" name="productscheckbox" class="a-center mr-5"
                                        type="checkbox" (change)="change()">
                                    <span>{{product.serviceName}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Promozioni ed Eventi</label>
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12" *ngFor="let promo of promoList">
                                    <input value="{{promo.id}}" name="promocheckbox" class="a-center mr-5"
                                        type="checkbox" (change)="change()">
                                    <span>{{promo.name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Categorie Dealer</label>
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"
                                    *ngFor="let dealer of dealerCategoryList">
                                    <input value="{{dealer.id}}" name="dealercheckbox" class="a-center mr-5"
                                        type="checkbox" (change)="change()">
                                    <span>{{dealer.name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Attività</label>
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"
                                    *ngFor="let activity of activitiesList">
                                    <input value="{{activity.id}}" name="activitiescheckbox" class="a-center mr-5"
                                        type="checkbox" (change)="change()">
                                    <span>{{activity.name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Centri Commerciali</label>
                            <div class="row max-h">
                                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"
                                    *ngFor="let mall of shoppingCentersList">
                                    <input value="{{mall.id}}" name="mallcheckbox" class="a-center mr-5"
                                        type="checkbox" (change)="change()">
                                    <span>{{mall.name}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-30">
                        <div class="m-3">
                            <label class="form-label label-fw">Store</label>
                            <ng-autocomplete #storeIds placeholder="Cerca Store" [data]="storeIdsSuggestion"
                                [searchKeyword]="storeIdsKeyword" (selected)='selectStoreIdsEvent($event)'
                                (inputChanged)='getStoreIdsList($event)' (inputFocused)='onStoreIdsFocused($event)'
                                [itemTemplate]="itemStoreIdsTemplate" (inputCleared)="searchStoreIdsCleared()"
                                [notFoundTemplate]="notFoundStoreIdsTemplate" [debounceTime]="600"
                                [isLoading]="isStoreIdsKeywordLoadingResult" [minQueryLength]="2">
                            </ng-autocomplete>
                            <ng-template #itemStoreIdsTemplate let-item>
                                <div class="col-12">
                                    <div class="mx-3">
                                        <span [innerHTML]="item.titleSeo"></span>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template #notFoundStoreIdsTemplate let-notFound>
                                {{errorStoreMsg}}
                            </ng-template>
                        </div>
                    </div>
                    <div class="col-12 mb-30">
                        <div class="m-3">
                            <fieldset class="fieldset-fw" [hidden]="storeSelected.length === 0">
                                <legend hidden></legend>
                                <app-draggable-list-chip [itemList]="storeSelected" [labelKeys]="labelKeysStoreIds"
                                    (changeItemList)="onChangeItemListStoreIdsSelected($event)">
                                </app-draggable-list-chip>
                            </fieldset>
                        </div>
                    </div>
                    <div class="col-12 mb-30">
                        <div class="m-3">
                            <label class="form-label label-fw">Note legali</label>
                            <ckeditor #legalNote="ngModel" [(ngModel)]="legalNoteValue"
                                [ngModelOptions]="{standalone: true}" name="legalNote" [config]="ckeConfig"
                                (ngModelChange)="change()" debounce="500">
                            </ckeditor>
                        </div>
                    </div>
                </div>
                <!--Buttons-->
                <div *ngIf="template === 'MAP'" class="row">
                    <div class="col-12">
                        <div class="my-4 text-center"><button
                                [disabled]="(form.status === 'INVALID' && form.touched === true) || form.touched === false "
                                (click)="clickButtonSave()" type="button" class="btn btn-fw text me-3">
                                Salva modifiche</button>
                            <button (click)="clickButtonCancel()" type="button"
                                class="btn btn-outline-fw text">Annulla</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>